export function isRunningInAFunctionalTest() {
    return process?.env?.JEST_WORKER_ID !== undefined;
}
